import { jsx as _jsx } from "react/jsx-runtime";
import { useSeparator } from "react-aria";
import styled, { css } from "styled-components";
const Separator = styled.hr(({ theme }) => css `
    width: 100%;
    height: 1px;
    border: 0;
    background: ${theme.colors.gray};
    margin: 0;
  `);
const HorizontalSeparator = (props) => {
    const { separatorProps } = useSeparator(Object.assign(Object.assign({}, props), { orientation: "horizontal" }));
    return (_jsx(Separator, Object.assign({}, props, separatorProps)));
};
export default HorizontalSeparator;
